module.exports = __webpack_public_path__ + "media/images/ic-information-cbb8d729fa4776799e9c3c2695d1b433.svg";